const mobileWrapper = theme => ({
  container: {
    //paddingTop: "20px",
    [theme.breakpoints.down("sm")]: {
      //backgroundColor: "black"
    }
  },
  containerMobileButton: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    padding: "10px",
   backgroundColor: "white",
    boxShadow:
      "0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15)"
    // backgroundColor: "#eeeeee"
  },
  buttonBig: {
    width: "100%",
    bordeRadius: "4px",
    height: "40px",
    margin: "0px",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    padding: "10px"
  },
  buttonBigText: {
    fontSize: "15px",
    fontFamily: "'Archivo Narrow', sans-serif",
    color: "white",
    lineHeight: "20px",
    textAlign: "center"
  },
  logo: {
    padding: "15px 0px 90px 0",
    margin: "0",
    display: "block",
    position: "relative",
    textAlign: "center",
    // zIndex: "1",
    // "&:after": {
    //   content: '""',
    //   position: "absolute",
    //   bottom: "0",
    //   height: "1px",
    //   right: "15px",
    //   width: "calc(100% - 30px)",
    //   backgroundColor: "hsla(0,0%,100%,.3)"
    // }
  },
  img: {
    width: "160px",
    verticalAlign: "middle",
    border: "0"
  },
  disabledLink: {
    pointerEvents: "none"
  },
  linkStyle: {
    width: "inherit"
  }
});

export default mobileWrapper;
